import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "rgb(var(--color-konnect-brand))",
      "fill-rule": "evenodd",
      d: "M8.567 17.813h3.67l1.906 2.397-.328.816H9.073l.116-.816-1.117-1.764zm2.626-10.527 1.967-.003L22 17.822l-.687 3.204h-3.788l.235-.903-8.26-9.85zM14.669 3l4.109 3.23-.526.543.712.992v1.06l-2.048 1.671-3.446-4.07h-2.006l.808-1.48zM6.043 13.344l2.867-2.491 3.804 4.578-1.08 1.678H8.126l-2.427 3.184-.554.733H2v-3.908l2.931-3.774z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }